import styled, { css } from "styled-components";

export const ProgressBar = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin: 1rem 0 1.5rem;
`;

export const ProgressStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.375rem;
`;

export const ProgressCircle = styled.div<{
  $completed: boolean;
  $active: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  width: 1.5rem;
  height: 1.5rem;

  border-radius: 50%;
  border: 2px solid;

  font-size: 0.75rem;
  font-weight: 600;
  transition:
    background-color 0.15s,
    color 0.15s;

  ${(p) => {
    let color = p.theme.text.muted;

    if (p.$completed) {
      color = p.theme.color.palette.kellyGreen;
    } else if (p.$active) {
      color = p.theme.text.highlight;
    }

    return css`
      color: ${color};
      border-color: ${color};
    `;
  }}
`;

export const ProgressLabel = styled.span<{
  $completed: boolean;
  $active: boolean;
}>`
  font-size: 0.6875rem;
  white-space: nowrap;
  color: ${(p) =>
    p.$completed || p.$active ? p.theme.text.default : p.theme.text.muted};
`;

export const Nav = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1.25rem;
`;

export const NavRight = styled.div`
  display: flex;
  gap: 0.5rem;
`;
